###
  Hideable and slideable tab panel (ex.: creatives moderation status)
###

class INTENT.utils.TabPanel

  @currentTab = null;

  options =
    isHideable = true

  @init: (target) ->
    panel = $(target);
    if target?
      $(document).on 'click', "#{target}.panel.with-nav-tabs .panel-heading span.collapse-button", () =>
        if !panel.find('.collapse-button').hasClass('panel-collapsed')
          @hidePanel(panel)
        else
          panel.find('.panel-heading .nav li:eq(1)').addClass('active');
          @showPanel(panel)

      $(document).on 'click', "#{target}.panel.with-nav-tabs .panel-heading .nav-tabs li a", (e) =>
        selectedTab = $(e.target).parent('a').attr('href') || $(e.target).attr('href')
        if !panel.find('.collapse-button').hasClass('panel-collapsed') && @currentTab == selectedTab
          @hidePanel(panel)
        else
          @showPanel(panel)
          @currentTab = selectedTab

      $(document).on 'click', "#{target}.panel.with-nav-tabs .panel-heading", (e) =>
        if !$(e.target).hasClass 'panel-heading'
          return;
        else if !panel.find('.collapse-button').hasClass('panel-collapsed') && panel.find('li.active').length
          @hidePanel(panel);

  @showPanel: (panel) ->
    panel.removeClass('panel-hidden')
    panel.find('.panel-body').slideDown(250)
    panel.find('.collapse-button').removeClass('panel-collapsed')
    panel.find('.collapse-button i').removeClass('glyphicon-chevron-down').addClass('glyphicon-chevron-up')

  @hidePanel: (panel) ->
    panel.find('.panel-body').slideUp 250, () ->
      panel.find('.panel-heading .nav li').removeClass('active')
      panel.find('.panel-body .tab-pane').removeClass('active').removeClass('in')
      panel.find('.panel-heading .nav li a').blur()
      panel.addClass('panel-hidden')
    panel.find('.collapse-button').addClass('panel-collapsed')
    panel.find('.collapse-button i').find('i').removeClass('glyphicon-chevron-up').addClass('glyphicon-chevron-down')
    @currentTab = null

